<template>
<div class="footBc">
    <div class="footInner">
        <div class="barBox">
            <div class="footBar">
                 <el-row :gutter="30">
                     <el-col :span="6" v-for="(navL, i) in navData" :key="i">
                         <p class="navTit" @click="handleSelect(i, navL.active)">
                             {{navL.title}}
                         </p>
                         <ul class="barLi">
                             <li v-for="(op, idx) in navL.options" :key="idx+op.title" @click="openPage(op.active)">
                                 {{op.title}}
                             </li>
                         </ul>

                     </el-col>
                </el-row>
            </div>
           <div class="wechatIcons">
                <img src="../../../static/images/icons/wechatIcon.png" style="margin-bottom:6px;" alt="微信图标">
                <br>
                <img src="../../../static/images/icons/QRCode.png" alt="微信二维码">
           </div>
        </div>
        <div class="ftB">
            <el-row :gutter="40">
                <el-col :span="4">
                    <!-- <img src="../../../static/images/logo/logo@2x.png" width="160" style="float:left;margin-top:-10px;"> -->
                </el-col>
                <!-- <el-col :span="5">
                    <span style="margin-right:20px;">
                        京公网安备11000002000001号
                    </span>
                </el-col> -->
                <el-col :span="3">
                    <span style="margin-right:20px;">
                        京ICP证030173号
                    </span>
                </el-col>
                <el-col :span="5">
                    <span style="margin-right:20px;">
                        © 2019 Betta. All rights reserved.
                    </span>
                </el-col>
                <el-col :span="7">
                    <span style="float:right;">
                        北京市海淀区西小口路66号中关村东升科技园B-6号楼C座4层
                    </span>
                </el-col>
            </el-row>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'pageFoot',
    data() {
        return {
            onNum: null,
            navData: [
                {
                    title: '关于贝塔',
                    active: 'introduce/1',
                    options: [
                        {
                            title: '贝塔简介',
                            active: 'introduce/betta1'
                        },
                        {
                            title: '愿景及使命',
                            active: 'introduce/betta2'
                        },
                        {
                            title: '发展历程',
                            active: 'introduce/betta3'
                        },
                        {
                            title: '管理团队',
                            active: 'introduce/betta4'
                        },
                        {
                            title: '企业文化',
                            active: 'introduce/betta5'
                        },
                        {
                            title: '办公地点',
                            active: 'introduce/betta6'
                        },
                    ]
                },
                {
                    title: '贝塔游戏',
                    active: 'game',
                    options: [
                        {
                            title: 'Word Crossy',
                            active: 'game'
                        },
                        {
                            title: 'Golf Rival',
                            active: 'game'
                        },
                        {
                            title: 'Word Villas',
                            active: 'game'
                        },
                        {
                            title: 'Dream Home',
                            active: 'game'
                        },
                        {
                            title: '…',
                            active: 'game'
                        },
                    ]
                },
                {
                    title: '贝塔招聘',
                    active: 'recruit',
                    options: [
                        {
                            title: '校园招聘',
                            active: 'recruit'
                        },
                        {
                            title: '社会招聘 ',
                            active: 'recruit'
                        },
                        {
                            title: '贝塔内推',
                            active: 'recruit'
                        },
                    ]
                },
                {
                    title: '贝塔生活',
                    active: 'life',
                    options: [
                        {
                            title: '员工成长',
                            active: 'life'
                        },
                        {
                            title: '特色福利',
                            active: 'life'
                        },
                        {
                            title: '快乐工作',
                            active: 'life'
                        },
                    ]
                },
            ]
        }
    },
    methods: {
        openPage(url) {
            if (url == 'recruit') {
                window.open('https://jobs-bettagames.ourats.com/');
            } else {
                this.$router.push({path: '/'+url}); 
            }
                       
        },
        handleSelect(idx, str) {
            if (str != 'recruit') {
                this.openPage(str);
                this.onNum = idx;
                sessionStorage.setItem('onNum', idx);
            } else {
                window.open('https://jobs-bettagames.ourats.com/');
            }
        },
    }

}
</script>
<style scoped lang="less">
.footBc{
    width: 100%;
    height: 463px;
    position: relative;
    background: #000000;
    opacity: 1;
    .footInner{
        width: 1240px;
        margin: 0 auto;
        height:400px;
        .wechatIcons{
            float:right;
        }
        .barBox{
            border-bottom: 1px solid #7E7E82;
            height:260px;
            padding-top:50px;
        }
        .footBar{
            width:500px;
            color: #fff;
            text-align:left;
            float:left;
            .navTit{
                font-size:16px;
                cursor:pointer;
                margin-bottom:15px;
            }
            .barLi li{
                font-size:14px;
                line-height:30px;
                color:#B2B2B2;
                cursor:pointer;
                font-family: Source Han Sans CN;
                font-weight: 400;
            }
            .barLi li:hover, .navTit:hover{
                color:#FF545B;
            }
        }
        .ftB{
            text-align:left;
            color:#fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            padding: 50px 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/pageFoot.vue